// Phase 4 methods, identifiers 70 to 77.
//
// Channels change the delivery shape rather than adding features. A post is
// stored once and read on demand; there is deliberately no durable row per
// subscriber per post, because ten million subscribers would mean ten million
// writes for one message.

// @generated by protoc-gen-es v2.14.1 with parameter "target=ts"
// @generated from file chat/v1/methods_p4.proto (package chat.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Commit, Content, Conversation, Message as Message$1, PageInfo, PostDiscussionLink } from "./common_pb";
import { file_chat_v1_common } from "./common_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file chat/v1/methods_p4.proto.
 */
export const file_chat_v1_methods_p4: GenFile = /*@__PURE__*/
  fileDesc("ChhjaGF0L3YxL21ldGhvZHNfcDQucHJvdG8SB2NoYXQudjEibQoUQ3JlYXRlQ2hhbm5lbFJlcXVlc3QSDQoFdGl0bGUYASABKAkSHAoPcHVibGljX3VzZXJuYW1lGAIgASgJSACIAQESFAoMY2xpZW50X29wX2lkGAMgASgMQhIKEF9wdWJsaWNfdXNlcm5hbWUiZQoVQ3JlYXRlQ2hhbm5lbFJlc3BvbnNlEisKDGNvbnZlcnNhdGlvbhgBIAEoCzIVLmNoYXQudjEuQ29udmVyc2F0aW9uEh8KBmNvbW1pdBgCIAEoCzIPLmNoYXQudjEuQ29tbWl0InQKF1N1YnNjcmliZUNoYW5uZWxSZXF1ZXN0EhcKD2NvbnZlcnNhdGlvbl9pZBgBIAEoDBIZCgxpbnZpdGVfdG9rZW4YAiABKAlIAIgBARIUCgxjbGllbnRfb3BfaWQYAyABKAxCDwoNX2ludml0ZV90b2tlbiI7ChhTdWJzY3JpYmVDaGFubmVsUmVzcG9uc2USHwoGY29tbWl0GAEgASgLMg8uY2hhdC52MS5Db21taXQiSgoZVW5zdWJzY3JpYmVDaGFubmVsUmVxdWVzdBIXCg9jb252ZXJzYXRpb25faWQYASABKAwSFAoMY2xpZW50X29wX2lkGAIgASgMIj0KGlVuc3Vic2NyaWJlQ2hhbm5lbFJlc3BvbnNlEh8KBmNvbW1pdBgBIAEoCzIPLmNoYXQudjEuQ29tbWl0InYKElB1Ymxpc2hQb3N0UmVxdWVzdBIXCg9jb252ZXJzYXRpb25faWQYASABKAwSIQoHY29udGVudBgCIAEoCzIQLmNoYXQudjEuQ29udGVudBIOCgZzaWxlbnQYAyABKAgSFAoMY2xpZW50X29wX2lkGAQgASgMIjYKE1B1Ymxpc2hQb3N0UmVzcG9uc2USHwoGY29tbWl0GAEgASgLMg8uY2hhdC52MS5Db21taXQiZQoVTGlua0Rpc2N1c3Npb25SZXF1ZXN0EhIKCmNoYW5uZWxfaWQYASABKAwSFQoIZ3JvdXBfaWQYAiABKAxIAIgBARIUCgxjbGllbnRfb3BfaWQYAyABKAxCCwoJX2dyb3VwX2lkIjkKFkxpbmtEaXNjdXNzaW9uUmVzcG9uc2USHwoGY29tbWl0GAEgASgLMg8uY2hhdC52MS5Db21taXQiQAoRUmVjb3JkVmlld1JlcXVlc3QSFwoPY29udmVyc2F0aW9uX2lkGAEgASgMEhIKCm1lc3NhZ2VfaWQYAiABKAwiJgoSUmVjb3JkVmlld1Jlc3BvbnNlEhAKCGFjY2VwdGVkGAEgASgIIkMKF09wZW5DaGFubmVsSW5ib3hSZXF1ZXN0EhIKCmNoYW5uZWxfaWQYASABKAwSFAoMY2xpZW50X29wX2lkGAIgASgMImgKGE9wZW5DaGFubmVsSW5ib3hSZXNwb25zZRIrCgxjb252ZXJzYXRpb24YASABKAsyFS5jaGF0LnYxLkNvbnZlcnNhdGlvbhIfCgZjb21taXQYAiABKAsyDy5jaGF0LnYxLkNvbW1pdCKMAQoJUHVibGljSGl0EgwKBGtpbmQYASABKAkSCgoCaWQYAiABKAwSDQoFdGl0bGUYAyABKAkSFQoIdXNlcm5hbWUYBCABKAlIAIgBARImCgdtZXNzYWdlGAUgASgLMhAuY2hhdC52MS5NZXNzYWdlSAGIAQFCCwoJX3VzZXJuYW1lQgoKCF9tZXNzYWdlIt4BChNTZWFyY2hQdWJsaWNSZXF1ZXN0Eg0KBXF1ZXJ5GAEgASgJEi8KBGtpbmQYAiABKA4yIS5jaGF0LnYxLlNlYXJjaFB1YmxpY1JlcXVlc3QuS2luZBITCgZjdXJzb3IYAyABKAxIAIgBARINCgVsaW1pdBgEIAEoDSJYCgRLaW5kEhAKDEtJTkRfVU5LTk9XThAAEg0KCUtJTkRfVVNFUhABEg4KCktJTkRfR1JPVVAQAhIQCgxLSU5EX0NIQU5ORUwQAxINCglLSU5EX1BPU1QQBEIJCgdfY3Vyc29yIlwKFFNlYXJjaFB1YmxpY1Jlc3BvbnNlEiMKB3Jlc3VsdHMYASADKAsyEi5jaGF0LnYxLlB1YmxpY0hpdBIfCgRwYWdlGAIgASgLMhEuY2hhdC52MS5QYWdlSW5mbyKwAQoLQ2hhbm5lbEhlYWQSEgoKY2hhbm5lbF9pZBgBIAEoDBIQCghoZWFkX3NlcRgCIAEoAxINCgVlcG9jaBgDIAEoAxIWCg5wb2xpY3lfdmVyc2lvbhgEIAEoAxIQCghqb2luX3NlcRgFIAEoAxIVCg1sYXN0X3JlYWRfc2VxGAYgASgDEhQKDHVucmVhZF9jb3VudBgHIAEoDRIVCg11bnJlYWRfY2FwcGVkGAggASgIIkcKFkdldENoYW5uZWxIZWFkc1JlcXVlc3QSEwoGY3Vyc29yGAEgASgMSACIAQESDQoFbGltaXQYAiABKA1CCQoHX2N1cnNvciJ9ChdHZXRDaGFubmVsSGVhZHNSZXNwb25zZRIjCgVoZWFkcxgBIAMoCzIULmNoYXQudjEuQ2hhbm5lbEhlYWQSHwoEcGFnZRgCIAEoCzIRLmNoYXQudjEuUGFnZUluZm8SHAoUc3Vic2NyaXB0aW9uX3ZlcnNpb24YAyABKAMiSwocUmVzb2x2ZVBvc3REaXNjdXNzaW9uUmVxdWVzdBIXCg9jb252ZXJzYXRpb25faWQYASABKAwSEgoKbWVzc2FnZV9pZBgCIAEoDCJkCh1SZXNvbHZlUG9zdERpc2N1c3Npb25SZXNwb25zZRI0CgpkaXNjdXNzaW9uGAEgASgLMhsuY2hhdC52MS5Qb3N0RGlzY3Vzc2lvbkxpbmtIAIgBAUINCgtfZGlzY3Vzc2lvbirlAgoKTWV0aG9kSWRQNBIYChRNRVRIT0RfSURfUDRfVU5LTk9XThAAEhwKGE1FVEhPRF9JRF9DUkVBVEVfQ0hBTk5FTBBGEh8KG01FVEhPRF9JRF9TVUJTQ1JJQkVfQ0hBTk5FTBBHEiEKHU1FVEhPRF9JRF9VTlNVQlNDUklCRV9DSEFOTkVMEEgSGgoWTUVUSE9EX0lEX1BVQkxJU0hfUE9TVBBJEh0KGU1FVEhPRF9JRF9MSU5LX0RJU0NVU1NJT04QShIZChVNRVRIT0RfSURfUkVDT1JEX1ZJRVcQSxIgChxNRVRIT0RfSURfT1BFTl9DSEFOTkVMX0lOQk9YEEwSGwoXTUVUSE9EX0lEX1NFQVJDSF9QVUJMSUMQTRIfChtNRVRIT0RfSURfR0VUX0NIQU5ORUxfSEVBRFMQThIlCiFNRVRIT0RfSURfUkVTT0xWRV9QT1NUX0RJU0NVU1NJT04QT0JDChdjb20uZXhhbXBsZS5jaGF0Lmdlbi52MVABWiZleGFtcGxlLmNvbS9jaGF0L2dlbi9nby9jaGF0L3YxO2NoYXR2MWIGcHJvdG8z", [file_chat_v1_common]);

/**
 * @generated from message chat.v1.CreateChannelRequest
 */
export type CreateChannelRequest = Message<"chat.v1.CreateChannelRequest"> & {
  /**
   * @generated from field: string title = 1;
   */
  title: string;

  /**
   * @generated from field: optional string public_username = 2;
   */
  publicUsername?: string | undefined;

  /**
   * @generated from field: bytes client_op_id = 3;
   */
  clientOpId: Uint8Array;
};

/**
 * Describes the message chat.v1.CreateChannelRequest.
 * Use `create(CreateChannelRequestSchema)` to create a new message.
 */
export const CreateChannelRequestSchema: GenMessage<CreateChannelRequest> = /*@__PURE__*/
  messageDesc(file_chat_v1_methods_p4, 0);

/**
 * @generated from message chat.v1.CreateChannelResponse
 */
export type CreateChannelResponse = Message<"chat.v1.CreateChannelResponse"> & {
  /**
   * @generated from field: chat.v1.Conversation conversation = 1;
   */
  conversation?: Conversation | undefined;

  /**
   * @generated from field: chat.v1.Commit commit = 2;
   */
  commit?: Commit | undefined;
};

/**
 * Describes the message chat.v1.CreateChannelResponse.
 * Use `create(CreateChannelResponseSchema)` to create a new message.
 */
export const CreateChannelResponseSchema: GenMessage<CreateChannelResponse> = /*@__PURE__*/
  messageDesc(file_chat_v1_methods_p4, 1);

/**
 * @generated from message chat.v1.SubscribeChannelRequest
 */
export type SubscribeChannelRequest = Message<"chat.v1.SubscribeChannelRequest"> & {
  /**
   * @generated from field: bytes conversation_id = 1;
   */
  conversationId: Uint8Array;

  /**
   * @generated from field: optional string invite_token = 2;
   */
  inviteToken?: string | undefined;

  /**
   * @generated from field: bytes client_op_id = 3;
   */
  clientOpId: Uint8Array;
};

/**
 * Describes the message chat.v1.SubscribeChannelRequest.
 * Use `create(SubscribeChannelRequestSchema)` to create a new message.
 */
export const SubscribeChannelRequestSchema: GenMessage<SubscribeChannelRequest> = /*@__PURE__*/
  messageDesc(file_chat_v1_methods_p4, 2);

/**
 * @generated from message chat.v1.SubscribeChannelResponse
 */
export type SubscribeChannelResponse = Message<"chat.v1.SubscribeChannelResponse"> & {
  /**
   * @generated from field: chat.v1.Commit commit = 1;
   */
  commit?: Commit | undefined;
};

/**
 * Describes the message chat.v1.SubscribeChannelResponse.
 * Use `create(SubscribeChannelResponseSchema)` to create a new message.
 */
export const SubscribeChannelResponseSchema: GenMessage<SubscribeChannelResponse> = /*@__PURE__*/
  messageDesc(file_chat_v1_methods_p4, 3);

/**
 * @generated from message chat.v1.UnsubscribeChannelRequest
 */
export type UnsubscribeChannelRequest = Message<"chat.v1.UnsubscribeChannelRequest"> & {
  /**
   * @generated from field: bytes conversation_id = 1;
   */
  conversationId: Uint8Array;

  /**
   * @generated from field: bytes client_op_id = 2;
   */
  clientOpId: Uint8Array;
};

/**
 * Describes the message chat.v1.UnsubscribeChannelRequest.
 * Use `create(UnsubscribeChannelRequestSchema)` to create a new message.
 */
export const UnsubscribeChannelRequestSchema: GenMessage<UnsubscribeChannelRequest> = /*@__PURE__*/
  messageDesc(file_chat_v1_methods_p4, 4);

/**
 * @generated from message chat.v1.UnsubscribeChannelResponse
 */
export type UnsubscribeChannelResponse = Message<"chat.v1.UnsubscribeChannelResponse"> & {
  /**
   * @generated from field: chat.v1.Commit commit = 1;
   */
  commit?: Commit | undefined;
};

/**
 * Describes the message chat.v1.UnsubscribeChannelResponse.
 * Use `create(UnsubscribeChannelResponseSchema)` to create a new message.
 */
export const UnsubscribeChannelResponseSchema: GenMessage<UnsubscribeChannelResponse> = /*@__PURE__*/
  messageDesc(file_chat_v1_methods_p4, 5);

/**
 * PublishPost uses the same message transaction as an ordinary send and adds
 * silent-notification metadata.
 *
 * Silent affects notification only. The post still enters history and still
 * reaches live subscriptions, because suppressing delivery would make a silent
 * post invisible to anyone reading at that moment rather than merely quiet.
 *
 * @generated from message chat.v1.PublishPostRequest
 */
export type PublishPostRequest = Message<"chat.v1.PublishPostRequest"> & {
  /**
   * @generated from field: bytes conversation_id = 1;
   */
  conversationId: Uint8Array;

  /**
   * @generated from field: chat.v1.Content content = 2;
   */
  content?: Content | undefined;

  /**
   * @generated from field: bool silent = 3;
   */
  silent: boolean;

  /**
   * @generated from field: bytes client_op_id = 4;
   */
  clientOpId: Uint8Array;
};

/**
 * Describes the message chat.v1.PublishPostRequest.
 * Use `create(PublishPostRequestSchema)` to create a new message.
 */
export const PublishPostRequestSchema: GenMessage<PublishPostRequest> = /*@__PURE__*/
  messageDesc(file_chat_v1_methods_p4, 6);

/**
 * @generated from message chat.v1.PublishPostResponse
 */
export type PublishPostResponse = Message<"chat.v1.PublishPostResponse"> & {
  /**
   * @generated from field: chat.v1.Commit commit = 1;
   */
  commit?: Commit | undefined;
};

/**
 * Describes the message chat.v1.PublishPostResponse.
 * Use `create(PublishPostResponseSchema)` to create a new message.
 */
export const PublishPostResponseSchema: GenMessage<PublishPostResponse> = /*@__PURE__*/
  messageDesc(file_chat_v1_methods_p4, 7);

/**
 * LinkDiscussion attaches a group as a channel's comment thread.
 *
 * It requires administration rights in BOTH conversations. Channel visibility
 * does not bypass the discussion group's own join and history policy: linking
 * is a navigation convenience, never a grant of access.
 *
 * @generated from message chat.v1.LinkDiscussionRequest
 */
export type LinkDiscussionRequest = Message<"chat.v1.LinkDiscussionRequest"> & {
  /**
   * @generated from field: bytes channel_id = 1;
   */
  channelId: Uint8Array;

  /**
   * @generated from field: optional bytes group_id = 2;
   */
  groupId?: Uint8Array | undefined;

  /**
   * @generated from field: bytes client_op_id = 3;
   */
  clientOpId: Uint8Array;
};

/**
 * Describes the message chat.v1.LinkDiscussionRequest.
 * Use `create(LinkDiscussionRequestSchema)` to create a new message.
 */
export const LinkDiscussionRequestSchema: GenMessage<LinkDiscussionRequest> = /*@__PURE__*/
  messageDesc(file_chat_v1_methods_p4, 8);

/**
 * @generated from message chat.v1.LinkDiscussionResponse
 */
export type LinkDiscussionResponse = Message<"chat.v1.LinkDiscussionResponse"> & {
  /**
   * @generated from field: chat.v1.Commit commit = 1;
   */
  commit?: Commit | undefined;
};

/**
 * Describes the message chat.v1.LinkDiscussionResponse.
 * Use `create(LinkDiscussionResponseSchema)` to create a new message.
 */
export const LinkDiscussionResponseSchema: GenMessage<LinkDiscussionResponse> = /*@__PURE__*/
  messageDesc(file_chat_v1_methods_p4, 9);

/**
 * RecordView contributes to an approximate view count.
 *
 * Views are deduplicated per account per post per day and aggregated. They are
 * explicitly not delivery or read receipts, and they are never presented as
 * such: a channel post has no recipient list to report against.
 *
 * @generated from message chat.v1.RecordViewRequest
 */
export type RecordViewRequest = Message<"chat.v1.RecordViewRequest"> & {
  /**
   * @generated from field: bytes conversation_id = 1;
   */
  conversationId: Uint8Array;

  /**
   * @generated from field: bytes message_id = 2;
   */
  messageId: Uint8Array;
};

/**
 * Describes the message chat.v1.RecordViewRequest.
 * Use `create(RecordViewRequestSchema)` to create a new message.
 */
export const RecordViewRequestSchema: GenMessage<RecordViewRequest> = /*@__PURE__*/
  messageDesc(file_chat_v1_methods_p4, 10);

/**
 * @generated from message chat.v1.RecordViewResponse
 */
export type RecordViewResponse = Message<"chat.v1.RecordViewResponse"> & {
  /**
   * @generated from field: bool accepted = 1;
   */
  accepted: boolean;
};

/**
 * Describes the message chat.v1.RecordViewResponse.
 * Use `create(RecordViewResponseSchema)` to create a new message.
 */
export const RecordViewResponseSchema: GenMessage<RecordViewResponse> = /*@__PURE__*/
  messageDesc(file_chat_v1_methods_p4, 11);

/**
 * @generated from message chat.v1.OpenChannelInboxRequest
 */
export type OpenChannelInboxRequest = Message<"chat.v1.OpenChannelInboxRequest"> & {
  /**
   * @generated from field: bytes channel_id = 1;
   */
  channelId: Uint8Array;

  /**
   * @generated from field: bytes client_op_id = 2;
   */
  clientOpId: Uint8Array;
};

/**
 * Describes the message chat.v1.OpenChannelInboxRequest.
 * Use `create(OpenChannelInboxRequestSchema)` to create a new message.
 */
export const OpenChannelInboxRequestSchema: GenMessage<OpenChannelInboxRequest> = /*@__PURE__*/
  messageDesc(file_chat_v1_methods_p4, 12);

/**
 * @generated from message chat.v1.OpenChannelInboxResponse
 */
export type OpenChannelInboxResponse = Message<"chat.v1.OpenChannelInboxResponse"> & {
  /**
   * @generated from field: chat.v1.Conversation conversation = 1;
   */
  conversation?: Conversation | undefined;

  /**
   * @generated from field: chat.v1.Commit commit = 2;
   */
  commit?: Commit | undefined;
};

/**
 * Describes the message chat.v1.OpenChannelInboxResponse.
 * Use `create(OpenChannelInboxResponseSchema)` to create a new message.
 */
export const OpenChannelInboxResponseSchema: GenMessage<OpenChannelInboxResponse> = /*@__PURE__*/
  messageDesc(file_chat_v1_methods_p4, 13);

/**
 * @generated from message chat.v1.PublicHit
 */
export type PublicHit = Message<"chat.v1.PublicHit"> & {
  /**
   * @generated from field: string kind = 1;
   */
  kind: string;

  /**
   * @generated from field: bytes id = 2;
   */
  id: Uint8Array;

  /**
   * @generated from field: string title = 3;
   */
  title: string;

  /**
   * @generated from field: optional string username = 4;
   */
  username?: string | undefined;

  /**
   * @generated from field: optional chat.v1.Message message = 5;
   */
  message?: Message$1 | undefined;
};

/**
 * Describes the message chat.v1.PublicHit.
 * Use `create(PublicHitSchema)` to create a new message.
 */
export const PublicHitSchema: GenMessage<PublicHit> = /*@__PURE__*/
  messageDesc(file_chat_v1_methods_p4, 14);

/**
 * @generated from message chat.v1.SearchPublicRequest
 */
export type SearchPublicRequest = Message<"chat.v1.SearchPublicRequest"> & {
  /**
   * @generated from field: string query = 1;
   */
  query: string;

  /**
   * @generated from field: chat.v1.SearchPublicRequest.Kind kind = 2;
   */
  kind: SearchPublicRequest_Kind;

  /**
   * @generated from field: optional bytes cursor = 3;
   */
  cursor?: Uint8Array | undefined;

  /**
   * @generated from field: uint32 limit = 4;
   */
  limit: number;
};

/**
 * Describes the message chat.v1.SearchPublicRequest.
 * Use `create(SearchPublicRequestSchema)` to create a new message.
 */
export const SearchPublicRequestSchema: GenMessage<SearchPublicRequest> = /*@__PURE__*/
  messageDesc(file_chat_v1_methods_p4, 15);

/**
 * @generated from enum chat.v1.SearchPublicRequest.Kind
 */
export enum SearchPublicRequest_Kind {
  /**
   * @generated from enum value: KIND_UNKNOWN = 0;
   */
  UNKNOWN = 0,

  /**
   * @generated from enum value: KIND_USER = 1;
   */
  USER = 1,

  /**
   * @generated from enum value: KIND_GROUP = 2;
   */
  GROUP = 2,

  /**
   * @generated from enum value: KIND_CHANNEL = 3;
   */
  CHANNEL = 3,

  /**
   * @generated from enum value: KIND_POST = 4;
   */
  POST = 4,
}

/**
 * Describes the enum chat.v1.SearchPublicRequest.Kind.
 */
export const SearchPublicRequest_KindSchema: GenEnum<SearchPublicRequest_Kind> = /*@__PURE__*/
  enumDesc(file_chat_v1_methods_p4, 15, 0);

/**
 * @generated from message chat.v1.SearchPublicResponse
 */
export type SearchPublicResponse = Message<"chat.v1.SearchPublicResponse"> & {
  /**
   * @generated from field: repeated chat.v1.PublicHit results = 1;
   */
  results: PublicHit[];

  /**
   * @generated from field: chat.v1.PageInfo page = 2;
   */
  page?: PageInfo | undefined;
};

/**
 * Describes the message chat.v1.SearchPublicResponse.
 * Use `create(SearchPublicResponseSchema)` to create a new message.
 */
export const SearchPublicResponseSchema: GenMessage<SearchPublicResponse> = /*@__PURE__*/
  messageDesc(file_chat_v1_methods_p4, 16);

/**
 * ChannelHead is where one subscribed channel now stands.
 *
 * Head values are observations made while this page was built, not a consistent
 * snapshot across the whole listing: a channel on page one may have moved by the
 * time page three is read. That is deliberate and is why no snapshot instant is
 * fixed — holding one across a client's whole enumeration would be per-subscriber
 * server state, which is exactly what a channel must not cost.
 *
 * @generated from message chat.v1.ChannelHead
 */
export type ChannelHead = Message<"chat.v1.ChannelHead"> & {
  /**
   * @generated from field: bytes channel_id = 1;
   */
  channelId: Uint8Array;

  /**
   * @generated from field: int64 head_seq = 2;
   */
  headSeq: bigint;

  /**
   * @generated from field: int64 epoch = 3;
   */
  epoch: bigint;

  /**
   * @generated from field: int64 policy_version = 4;
   */
  policyVersion: bigint;

  /**
   * The subscription's sequence boundary. Section 06 resolves a subscription
   * racing a publication by which side of this the post falls on.
   *
   * @generated from field: int64 join_seq = 5;
   */
  joinSeq: bigint;

  /**
   * -1 for a subscriber who has read nothing.
   *
   * @generated from field: int64 last_read_seq = 6;
   */
  lastReadSeq: bigint;

  /**
   * Counted message creations, capped at 999. Edits, deletions and membership
   * changes occupy sequences too, so subtracting sequence numbers would report a
   * channel as unread because somebody fixed a typo.
   *
   * @generated from field: uint32 unread_count = 7;
   */
  unreadCount: number;

  /**
   * True only above the cap, so a channel with exactly 999 unread posts is not
   * reported as an estimate.
   *
   * @generated from field: bool unread_capped = 8;
   */
  unreadCapped: boolean;
};

/**
 * Describes the message chat.v1.ChannelHead.
 * Use `create(ChannelHeadSchema)` to create a new message.
 */
export const ChannelHeadSchema: GenMessage<ChannelHead> = /*@__PURE__*/
  messageDesc(file_chat_v1_methods_p4, 17);

/**
 * GetChannelHeads pages a subscriber's channels and reports where each stands.
 *
 * This is the recovery half of pull delivery. A client that was away missed
 * every invalidation sent while it was gone, and no durable record of what it
 * missed exists — deliberately, because that record is the per-subscriber write
 * per post that a channel must not pay for. It asks where its channels are now
 * and pages history for the ones that moved.
 *
 * @generated from message chat.v1.GetChannelHeadsRequest
 */
export type GetChannelHeadsRequest = Message<"chat.v1.GetChannelHeadsRequest"> & {
  /**
   * @generated from field: optional bytes cursor = 1;
   */
  cursor?: Uint8Array | undefined;

  /**
   * @generated from field: uint32 limit = 2;
   */
  limit: number;
};

/**
 * Describes the message chat.v1.GetChannelHeadsRequest.
 * Use `create(GetChannelHeadsRequestSchema)` to create a new message.
 */
export const GetChannelHeadsRequestSchema: GenMessage<GetChannelHeadsRequest> = /*@__PURE__*/
  messageDesc(file_chat_v1_methods_p4, 18);

/**
 * @generated from message chat.v1.GetChannelHeadsResponse
 */
export type GetChannelHeadsResponse = Message<"chat.v1.GetChannelHeadsResponse"> & {
  /**
   * @generated from field: repeated chat.v1.ChannelHead heads = 1;
   */
  heads: ChannelHead[];

  /**
   * @generated from field: chat.v1.PageInfo page = 2;
   */
  page?: PageInfo | undefined;

  /**
   * Advances only when the set of subscriptions changes, including a leave and
   * rejoin — never for a post or a read position. A client reconciles removals
   * only after a complete enumeration at one version; if this moves mid-walk the
   * server answers RESET_REQUIRED rather than letting the client conclude that a
   * channel it simply did not reach has been unsubscribed.
   *
   * @generated from field: int64 subscription_version = 3;
   */
  subscriptionVersion: bigint;
};

/**
 * Describes the message chat.v1.GetChannelHeadsResponse.
 * Use `create(GetChannelHeadsResponseSchema)` to create a new message.
 */
export const GetChannelHeadsResponseSchema: GenMessage<GetChannelHeadsResponse> = /*@__PURE__*/
  messageDesc(file_chat_v1_methods_p4, 19);

/**
 * ResolvePostDiscussion navigates between a channel post and its comment thread.
 *
 * It answers in both directions, and from a comment as well: given any of the
 * post, the anchor, or a comment in the anchor's thread, it returns the one
 * pairing they all belong to.
 *
 * @generated from message chat.v1.ResolvePostDiscussionRequest
 */
export type ResolvePostDiscussionRequest = Message<"chat.v1.ResolvePostDiscussionRequest"> & {
  /**
   * @generated from field: bytes conversation_id = 1;
   */
  conversationId: Uint8Array;

  /**
   * @generated from field: bytes message_id = 2;
   */
  messageId: Uint8Array;
};

/**
 * Describes the message chat.v1.ResolvePostDiscussionRequest.
 * Use `create(ResolvePostDiscussionRequestSchema)` to create a new message.
 */
export const ResolvePostDiscussionRequestSchema: GenMessage<ResolvePostDiscussionRequest> = /*@__PURE__*/
  messageDesc(file_chat_v1_methods_p4, 20);

/**
 * @generated from message chat.v1.ResolvePostDiscussionResponse
 */
export type ResolvePostDiscussionResponse = Message<"chat.v1.ResolvePostDiscussionResponse"> & {
  /**
   * Absent when the source is readable but the pairing is not: either there is
   * no thread, or the other endpoint is not readable by this caller. The two are
   * deliberately indistinguishable, so an absent link cannot be used to detect
   * the existence of a conversation the caller may not see.
   *
   * @generated from field: optional chat.v1.PostDiscussionLink discussion = 1;
   */
  discussion?: PostDiscussionLink | undefined;
};

/**
 * Describes the message chat.v1.ResolvePostDiscussionResponse.
 * Use `create(ResolvePostDiscussionResponseSchema)` to create a new message.
 */
export const ResolvePostDiscussionResponseSchema: GenMessage<ResolvePostDiscussionResponse> = /*@__PURE__*/
  messageDesc(file_chat_v1_methods_p4, 21);

/**
 * @generated from enum chat.v1.MethodIdP4
 */
export enum MethodIdP4 {
  /**
   * @generated from enum value: METHOD_ID_P4_UNKNOWN = 0;
   */
  METHOD_ID_P4_UNKNOWN = 0,

  /**
   * @generated from enum value: METHOD_ID_CREATE_CHANNEL = 70;
   */
  METHOD_ID_CREATE_CHANNEL = 70,

  /**
   * @generated from enum value: METHOD_ID_SUBSCRIBE_CHANNEL = 71;
   */
  METHOD_ID_SUBSCRIBE_CHANNEL = 71,

  /**
   * @generated from enum value: METHOD_ID_UNSUBSCRIBE_CHANNEL = 72;
   */
  METHOD_ID_UNSUBSCRIBE_CHANNEL = 72,

  /**
   * @generated from enum value: METHOD_ID_PUBLISH_POST = 73;
   */
  METHOD_ID_PUBLISH_POST = 73,

  /**
   * @generated from enum value: METHOD_ID_LINK_DISCUSSION = 74;
   */
  METHOD_ID_LINK_DISCUSSION = 74,

  /**
   * @generated from enum value: METHOD_ID_RECORD_VIEW = 75;
   */
  METHOD_ID_RECORD_VIEW = 75,

  /**
   * @generated from enum value: METHOD_ID_OPEN_CHANNEL_INBOX = 76;
   */
  METHOD_ID_OPEN_CHANNEL_INBOX = 76,

  /**
   * @generated from enum value: METHOD_ID_SEARCH_PUBLIC = 77;
   */
  METHOD_ID_SEARCH_PUBLIC = 77,

  /**
   * @generated from enum value: METHOD_ID_GET_CHANNEL_HEADS = 78;
   */
  METHOD_ID_GET_CHANNEL_HEADS = 78,

  /**
   * @generated from enum value: METHOD_ID_RESOLVE_POST_DISCUSSION = 79;
   */
  METHOD_ID_RESOLVE_POST_DISCUSSION = 79,
}

/**
 * Describes the enum chat.v1.MethodIdP4.
 */
export const MethodIdP4Schema: GenEnum<MethodIdP4> = /*@__PURE__*/
  enumDesc(file_chat_v1_methods_p4, 0);

